export default __webpack_public_path__ + "static/media/bg-red-noise.e4ecaa99.png";